import { uniq } from '../../../../utils/helper/lodash_replacements';
import { Subtopic } from '../../subtopic/Subtopic';
export class TopicSubtopics {
    parent;
    constructor(parent) {
        this.parent = parent;
    }
    get topic() {
        return this.parent;
    }
    get subtopics() {
        return uniq(this.topic.topicMiniQuestions.miniQuestions.map(mini => mini.micro.subtopicName)).map(subtopicName => this.subtopicByName(subtopicName));
    }
    mem = new Map();
    subtopicByName(name) {
        if (this.mem.has(name)) {
            return this.mem.get(name);
        }
        const s = new Subtopic(this.topic, name);
        this.mem.set(name, s);
        return s;
    }
    get subtopicNames() {
        return uniq(this.topic.subtopics.map(subtopic => subtopic.name));
    }
    get storedSubtopics() {
        return this.subtopics.map(subtopic => ({ name: subtopic.name, count: subtopic.count }));
    }
}
